module.exports = __webpack_public_path__ + "static/media/online.5cb35bf3.gif";